module.exports = __webpack_public_path__ + "fonts/opensans-semibolditalic.b80ea6bf.woff2";